import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useGetQuizQuery } from "../../redux/features/quiz/quizAPI";
import { userLoggedOut } from "../../redux/features/auth/authSlice";
import EditQuizForm from "../../components/EditQuizForm";
import usePageTitle from "../../utils/usePageTitle";

export default function EditQuiz() {
  usePageTitle("Edit Quiz");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const { role } = JSON.parse(localStorage.auth).user;

    if (role !== "admin") {
      navigate("/admin");

      dispatch(userLoggedOut());
      window.localStorage.clear();
    }
  }, [dispatch, navigate]);

  const { quizId } = useParams();
  const { data: quiz, isLoading, isError, error } = useGetQuizQuery(quizId);

  let content = null;
  if (isLoading) {
    content = <div className="text-center mt-6">Loading...</div>;
  }
  if (!isLoading && isError) {
    content = <div className="text-center mt-6">{error}</div>;
  }
  if (!isLoading && !isError && quiz?.id) {
    content = <EditQuizForm quiz={quiz} />;
  }

  return (
    <div
      style={{
        minWidth: "50%",
        position: "absolute",
        top: "45%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
      className="container relative"
    >
      <h2 className="text-center text-3xl font-bold text-cyan">Edit Quiz</h2>
      <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
        {content}
      </div>
    </div>
  );
}
